import { render, staticRenderFns } from "./UserTransactions.vue?vue&type=template&id=50d7b1af&scoped=true"
import script from "./UserTransactions.vue?vue&type=script&lang=js"
export * from "./UserTransactions.vue?vue&type=script&lang=js"
import style0 from "./UserTransactions.vue?vue&type=style&index=0&id=50d7b1af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d7b1af",
  null
  
)

export default component.exports